import { render, staticRenderFns } from "./ProductSegmentDetail.vue?vue&type=template&id=52698ab0"
import script from "./ProductSegmentDetail.vue?vue&type=script&lang=ts"
export * from "./ProductSegmentDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports